export const GOODLOOK_VIEW_ACCESS = 'Goodlook-View-Access';
export const GOODLOOK_SNOWFLAKE_ACCESS = 'Goodlook-Snowflake-Access';
